<template>
    <div>
        <v-card flat class="rounded-0">
            <ValidationObserver ref="obs" v-slot="{ invalid }">
                <v-form name="formEditarFamiliar" @submit.prevent="enviarDatosFamiliar" class="my-2">
                    <v-row class="mt-0 pt-0">
                        <v-card-text class="font-weight-bold text-body-1 black--text text-uppercase">
                            {{ titulo }}
                        </v-card-text>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:50|alpha_spaces" v-slot="v">
                                <v-text-field dense v-model="itemDataSelected.nombres" :readonly="blockDatosFam"
                                    @input="itemDataSelected.nombres = itemDataSelected.nombres.toUpperCase()"
                                    :error-messages="v.errors[0]" label="Nombres">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:50|alpha_spaces" v-slot="v">
                                <v-text-field dense v-model="itemDataSelected.apellido" :readonly="blockDatosFam"
                                    @input="itemDataSelected.apellido = itemDataSelected.apellido.toUpperCase()"
                                    :error-messages="v.errors[0]" label="Apellido">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="5">
                            <ValidationProvider rules="required|minmax:7,8|alpha_num" v-slot="v">
                                <v-text-field dense v-model="itemDataSelected.nrodoc" hide-spin-buttons label="DNI Nro."
                                    :error-messages="v.errors[0]" @input="selectTipDoc" :readonly="blockDatosFam">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <!-- Las validaciones cambian al elegir pasaporte -->
                        <v-col cols="12" md="3">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-select dense v-model="itemDataSelected.sexo" :items="itemSexo" label="Sexo"
                                    item-value="item" item-text="item" :error-messages="v.errors[0]"
                                    :readonly="blockDatosFam"></v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-text-field v-model="itemDataSelected.fecnacim" dense label="Fecha de nacimiento:"
                                    type="date" :error-messages="v.errors[0]" :readonly="blockDatosFam"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-select dense v-model="itemDataSelected.tipnacionalidad" :error-messages="v.errors[0]"
                                    :readonly="blockDatosFam" @input="selectTipNacionalidad($event, index)"
                                    :items="tipoNacionalidad" item-value="tna_id" return-object
                                    item-text="tna_destipnac" label="Tipo de nacionalidad">
                                </v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-autocomplete dense v-model="itemDataSelected.nacionalidad"
                                    @input="selectNacionalidad($event, index)" return-object :items="nacionalidades"
                                    item-value="id" item-text="desnacionalidad" label="Nacionalidad"
                                    :error-messages="v.errors[0]" :readonly="blockDatosFam">
                                </v-autocomplete>
                            </ValidationProvider>
                        </v-col>
                        <!--                         <v-col cols="12" md="4" v-if="datosPersonales.estadocivil == 7">
                            <ValidationProvider rules="required|max:10|nofechafutura" v-slot="v">
                                <v-text-field v-model="itemDataSelected.fecfallecido" dense :label="labelFecha"
                                    type="date" :error-messages="v.errors[0]" :readonly="blockDatosFam"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="4" v-else>
                            <v-text-field v-model="itemDataSelected.fecestadocivil" dense :label="labelFecha"
                                :disabled="!mostrarFecha" readonly type="date"></v-text-field>
                        </v-col> -->
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required|max:10|nofechafutura" v-slot="v">
                                <v-text-field v-model="itemDataSelected.fecestadocivil" dense :label="labelFecha"
                                    type="date" :error-messages="v.errors[0]" :readonly="blockDatosFam"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-card-text class="font-weight-bold text-body-1 black--text ">
                            DOCUMENTACIÓN REQUERIDA:
                        </v-card-text>
                    </v-row>
                    <v-row class="d-flex flex-row align-end "
                        :class="($vuetify.breakpoint.mdAndDown) ? 'justify-center' : 'justify-space-around'">
                        <InputButtonArchivo v-if="dniRequired" @fileSelected="handleFileSelected" op="dniFrenteFamiliar"
                            label="DNI FRENTE" :subtitle="itemDataSelected.nombres + ' ' + itemDataSelected.apellido" />
                        <InputButtonArchivo v-if="dniRequired" @fileSelected="handleFileSelected" op="dniDorsoFamiliar"
                            label="DNI DORSO" :subtitle="itemDataSelected.nombres + ' ' + itemDataSelected.apellido" />
                        <InputButtonArchivo op="certFamiliar" :label="labelDocumento"
                            :subtitle="itemDataSelected.nombres + ' ' + itemDataSelected.apellido"
                            @fileSelected="handleFileSelected">
                        </InputButtonArchivo>
                    </v-row>
                    <v-row class="ma-10">
                        <v-divider></v-divider>
                    </v-row>
                    <v-card-actions class="custom-card-actions-ha d-flex flex-row " @click="forzarValidacion">
                        <v-btn elevation='0' @click="volverPaso" class="pa-5" color="primary">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>
                            atras
                        </v-btn>
                        <v-btn elevation='0' type="submit" class="pa-5" color="primary"
                            :disabled="invalid || !formValid">
                            <v-icon class="mr-2">mdi-send</v-icon>
                            enviar trámite
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Alertas from '@/components/alerts/Alertas.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import { mapGetters, mapActions } from 'vuex';


export default {
    components:
    {
        ValidationObserver,
        ValidationProvider,
        Alertas,
        InputButtonArchivo,
    },
    data() {
        return {
            labelInfo: '',
            labelTipoFamiliar: '',

            familiarSeleccionado: null,

            itemDataSelected: {
                id: '',
                nroafi: '',
                nombres: '',
                apellido: '',
                sexo: '',
                fecnacim: '',
                tipfamiliar: '',
                tipdoc: '',
                nrodoc: '',
                destipfamiliar: '',
                fecestadocivil: '',
                estadocivil: '',
                nacionalidad: '',
                desnacionalidad: '',
                tipnacionalidad: '',
                fecfallecido: '',
                discapacidad: 'N',
                accion: '',
                destipdoc: '',
            },
            fallecido: '',
            checkSubsidio: "0",

            indiceFam: '',

            itemTipDni: [
                { id: 1, item: 'DNI' },
                { id: 2, item: 'LE' },
                { id: 3, item: 'LC' },
                { id: 4, item: 'PAS' }
            ],
            // item select tipo de dni
            itemSexo: ['F', 'M', 'X'], // item select sexo

            formValid: false,
            blockDatosFam: false,

        }
    },
    created() {
    },
    mounted() {
        this.getFamiliar()
        this.itemDataSelected = this.familiar.filter(fam => (fam.estadocivil !== 1) && !((fam.tipfamiliar == 3) || (fam.tipfamiliar == 4) || (fam.tipfamiliar == 5)))[0];
        this.itemDataSelected.nroafi = this.nroafi
        this.itemDataSelected.accion = "M"
        if (this.mostrarFecha) {
            this.itemDataSelected.estadocivil = this.datosPersonales.estadocivil
            this.itemDataSelected.fecestadocivil = this.datosPersonales.fecestadocivil
        } else this.itemDataSelected.fecestadocivil = ''
        this.itemDataSelected.desestadocivil = this.estadoCivil.find(item => item.id == this.itemDataSelected.estadocivil).desestadocivil
    },
    computed: {
        ...mapGetters('common', ['tipoNacionalidad', 'estadoCivil', 'tiposFamiliares', 'nacionalidades']),
        ...mapGetters('itemEdit', ['itemSelected', 'indiceSelected']),
        ...mapGetters('auth', ['isAuthenticated', 'nroafi', 'user']),
        ...mapGetters(['familiar']),
        ...mapGetters('dataUser', ['dniFrenteFamiliar', 'dniDorsoFamiliar', 'certDiscFamiliar', 'certFamiliar', 'datosPersonales']),

        'temDataSelected.fecestadocivil'(value) {
            if (this.datosPersonales.estadocivil == 7) {
                this.itemDataSelected.fecfallecido = value
            } else {
                this.itemDataSelected.fecestadocivil = value
            }
        },
        dniRequired() {
            (this.datosPersonales.estadocivil == 7) || ((this.user.estadocivil == 9) && (this.datosPersonales.estadocivil == 1)) ? true : false
        },
        labelFecha() {
            switch (this.datosPersonales.estadocivil) {
                case 2:
                    return 'Fecha de matrimonio'
                case 5:
                    return 'Fecha de divorcio'
                case 7:
                    return 'Fecha de fallecimiento'
                case 9:
                    return 'Fecha de unión convivencial'
                case 11:
                    return 'Fecha de convivencia'
                default:
                    return 'Fecha de estado civil'
            }
        },

        labelDocumento() {
            switch (this.datosPersonales.estadocivil) {
                case 1:
                    if (this.user.estadocivil == 9) {
                        this.blockDatosFam = true
                        const text = 'Cese de Unión o Certificado de Defunción'
                        return text.toUpperCase()
                    }
                case 2:
                    return 'ACTA DE MATRIMONIO'
                case 5:
                    if (this.user.estadocivil == 2) {
                        this.blockDatosFam = true
                    }
                    return 'SENTENCIA DE DIVORCIO'
                case 7:
                    if (this.user.estadocivil == 2) { this.blockDatosFam = true }
                    return 'CERTIFICADO DE DEFUNCIÓN'
                case 9:
                    return 'CERTIFICADO DE UNIÓN CONVIVENCIAL'
                case 11:
                    return 'CERTIFICADO DE CONVIVENCIA'
                default:
                    return 'CERTIFICADO'
            }
        },

        titulo() {
            switch (this.datosPersonales.estadocivil) {
                case 2:
                    return 'Información de conyuge'
                case 5:
                    return 'Información de conyuge'
                case 7:
                    return 'Información de conyuge/conviviente fallecido'
                case 9:
                    return 'Información de conviviente'
                case 11:
                    return 'Información de conviviente'
                default:
                    return 'Información de conyuge/conviviente'
            }
        },
        mostrarFecha() {
            return (this.datosPersonales.estadocivil == 2) || (this.datosPersonales.estadocivil == 5) || (this.datosPersonales.estadocivil == 7) || (this.datosPersonales.estadocivil == 9)
        },
    },

    methods: {
        ...mapActions('dataUser', ['addFiles', 'deleteFiles', 'modificarFamiliar', 'agregarArchFam', 'preparaFormData', 'guardarDatosFamiliaresMasConyuge']),
        ...mapActions('preafiliacion', ['deleteFiles', 'saveDatosConyuge']),
        ...mapActions(['getFamiliar']),

        //control de inputButtons para habilitar el btn guardar
        handleFileSelected() {
            if (this.dniRequired) {
                this.formValid = (this.dniFrenteFamiliar.length !== 0 && this.dniDorsoFamiliar.length !== 0 && this.certFamiliar.length !== 0)
            } else {
                this.formValid = (this.certFamiliar.length !== 0)
            }
        },

        volverPaso() {
            this.$emit('volver')
        },

        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                let [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                let [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        //guardado localmente antes de hacer peticion a API
        guardarFamiliar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    //this.guardarDatosFamiliares(this.itemDataSelected)
                    this.preparaFormData()
                    //this.guardarDatosFamiliares({ familiar: this.familiarSeleccionado, indice: this.indiceSelected })
                    //vuelve a listado de familiares ()
                    //this.$emit('familiarGuardado')
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
            //this.actualizarDatos(formData)
        },
        async enviarDatosFamiliar() {
            if (!(await this.$refs.obs?.validate?.())) {
                this.showSnack({
                    type: "400",
                    message: "Formulario inválido, revisá los campos.",
                });
            } else {
                // Create a copy of the familiar array
                const familiarCopy = [...this.familiar];

                // Find the index of the selected object in the array
                const index = familiarCopy.findIndex(fam => fam.id == this.itemDataSelected.id);
                if (index !== -1) {
                    // Update the object in the copied array with the data from itemDataSelected
                    familiarCopy.splice(index, 1, { ...this.itemDataSelected });
                }

                // Add empty "accion" key to other family members
                familiarCopy.forEach(fam => {
                    if (fam.id !== this.itemDataSelected.id) {
                        fam.accion = '';
                    }
                });
                // Call the action to save the updated array
                this.guardarDatosFamiliaresMasConyuge(familiarCopy);
                this.preparaFormData();
                this.$emit('handleDialog')

            }
        },
        selectedEstadoCivil(value) {
            this.estadocivil = value.id
            this.desestadocivil = value.desestadocivil
        },
        selectNacionalidad(value) {
            this.itemDataSelected.nacionalidad = value.id
            this.itemDataSelected.desnacionalidad = value.desnacionalidad
        },
        selectTipNacionalidad(value) {
            this.itemDataSelected.tipnacionalidad = value.tna_id
            this.itemDataSelected.destipnacionalidad = value.tna_destipnac
        },
        selectTipDoc(value) {
            this.itemDataSelected.tipdoc = value.id
            this.itemDataSelected.destipdoc = value.item
        },
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        selectTipFamiliar(value) {
            if (value.id == 1) {
                this.labelInfo = "certificado de matrimonio"
                this.labelTipoFamiliar = "CERT. MATRIMONIO"
            }
            else if (value.id == 2) {
                this.labelInfo = "certificado de convivencia"
                this.labelTipoFamiliar = "CERT. CONVIVENCIA"
            }
            /*             else if (value.id == 3) {
                            this.labelInfo = "acta de nacimiento"
                            this.labelTipoFamiliar = "ACTA. NACIMIENTO"
                        } */
            else {
                this.labelInfo = ""
                this.labelTipoFamiliar = ""
            }
            this.itemDataSelected.tipfamiliar = value.id
            this.itemDataSelected.destipfamiliar = value.desfamiliar
        },

        calcularFechaSuma18Anios(fechaNacimiento) {
            if (!fechaNacimiento) return null;
            const fecha = new Date(fechaNacimiento);
            fecha.setFullYear(fecha.getFullYear() + 18);
            return fecha.toISOString().split('T')[0]; // Formato YYYY-MM-DD
        },


    },
}

</script>